import UserService from './UserService';
import MenuService from './MenuService';
import StoreService from './StoreService';
import CustomerService from './CustomerService';
import RememberService from './RememberService';
import FileService from './FileService';

export { UserService, MenuService, StoreService, CustomerService, RememberService, FileService };
